import React from 'react';
import QRCode from 'qrcode.react';

export type QrCodeProps = {
  value: string;
};

export const QrCode: React.FC<QrCodeProps> = ({ value }: QrCodeProps) => {
  return <QRCode data-testid="handoff-qr-code" value={value} size={220} includeMargin />;
};
